module.exports = __webpack_public_path__ + "img/new12.1d318bf1.png";